import React from 'react';
import { Icon } from 'antd';
import './style.less';

interface TaobaoButtonProps {
  content: string | React.ReactNode,
  style?: React.CSSProperties,
  theme?: 'primary' | 'default',
  width?: string,
  onClick?: () => void,
  id?: string,
  disabled?: boolean,
  loading?: boolean,
  className?: string,
}

const clsPrefix = 'c-taobao-button';
const TaobaoButton: React.FC<TaobaoButtonProps> = ({
  content = '',
  style = {},
  theme = 'default',
  width = '144px',
  onClick = () => null,
  id,
  disabled = false,
  loading = false,
  className = ""
}) => {
  const disabledStyle = disabled ? { opacity: "0.5" } : {};
  const loadingStyle = loading ? { marginLeft: '-5px' } : {}; 
  return (
    <button
      onClick={onClick}
      className={`${clsPrefix} ${clsPrefix}--${theme} ${className}`}
      style={{ width, ...style, ...disabledStyle }}
      id={id}
      disabled={disabled}
    >
      <div style={{...loadingStyle}}>
        {
          loading && <Icon type="loading" style={{ marginRight: '5px' }} />
        }
        {content}
      </div>
    </button>
  )
}

export default TaobaoButton;